__turbopack_context__.v({
  "btn": "styles-module-scss-module__4299Oa__btn",
  "btnContainer": "styles-module-scss-module__4299Oa__btnContainer",
  "displayBlockDesktop": "styles-module-scss-module__4299Oa__displayBlockDesktop",
  "enrollNowCROPage": "styles-module-scss-module__4299Oa__enrollNowCROPage",
  "fixedHeader": "styles-module-scss-module__4299Oa__fixedHeader",
  "header": "styles-module-scss-module__4299Oa__header",
  "headerContainer": "styles-module-scss-module__4299Oa__headerContainer",
  "headeraonsat": "styles-module-scss-module__4299Oa__headeraonsat",
  "hideArrow": "styles-module-scss-module__4299Oa__hideArrow",
  "isProgramListPageHeader": "styles-module-scss-module__4299Oa__isProgramListPageHeader",
  "logo": "styles-module-scss-module__4299Oa__logo",
  "studentLogin": "styles-module-scss-module__4299Oa__studentLogin",
  "svgHover": "styles-module-scss-module__4299Oa__svgHover",
});
